/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { Loader } from 'src/components';
import Form from '../../components/AuthForm';
import { AuthorizationFormViewRendererProps } from '../../types';

function Desktop(props: AuthorizationFormViewRendererProps) {
  const { loading } = props;
  return (
    <>
      <Form {...props} />
      {loading && (
        <div className="fixed top-[50vh] left-[50vw]">
          <Loader />
        </div>
      )}
    </>
  );
}

export default Desktop;
